<template>
	<div>
		<div class="col-xs-12 col-lg-12 pagination pagination-top">
			<div class="row">
				<div v-if="selected !== undefined && !is_selected" class="col-xs-6 col-lg-6 pagination-total">
					Selecionado {{ countSelected() }} de {{ total }} {{ label }}.
				</div>
				<div v-else-if="selected !== undefined && is_selected" class="col-xs-6 col-lg-6 pagination-total">
					Selecionado {{ selected.length }} {{ label }}.
				</div>
				<div v-else class="col-xs-6 col-lg-6 pagination-total">
					Mostrando {{ total }} {{ label }}.
				</div>
				<div class="col-xs-6 col-lg-6 weight-capacity-total">
					<div class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-truck-loading"></i> Capacidade </span>
						<span class="weight-capacity-right">{{ getWeightCapacity(selected_weight_capacity) }}</span>
					</div>
					<div v-if="label == 'entregas'" class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-weight-hanging"></i> Peso </span>
						<span class="weight-capacity-right">{{ getWeight(selected_weight) }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12 col-lg-12" style="padding: 0px;">
			<div class="table-wrapper">
				<table class="table">
					<thead>
						<tr>
							<th v-if="(select_all !== undefined) && (selected !== undefined)" @click="select_all()" class="pointered" style="width: 30px;">
								<i v-if="verifySelectedAll(list, selected, true)" class="fas fa-fw fa-check-square"></i>
								<i v-else class="far fa-fw fa-square"></i>
							</th>
							<th v-for="(header, idx) in headers" :key="idx">
								<button v-if="(ordering !== undefined) && ordering.includes(idx)" class="order" :class="{'active': (order_field == idx)}" @click="reorder(idx)">
									{{ header }}
									<i v-if="order_direction == 'DESC'" class="fa fa-fw fa-caret-up"></i>
									<i v-if="order_direction == 'ASC'"  class="fa fa-fw fa-caret-down"></i>
								</button>
								<button v-else class="order">
									{{ header }}
								</button>
							</th>
							<th v-if="selected_return_origin !== undefined" @click="select_all_return_origin()" class="pointered">
								<button class="order">
									<i v-if="verifySelectedAll(list, selected_return_origin, false)" class="fas fa-fw fa-check-square"></i>
									<i v-else class="far fa-fw fa-square"></i>
									Retornar a origem
								</button>
							</th>
							<th v-if="$slots.default !== undefined">
								<button class="order">
									Opções
								</button>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="loading">
							<td :colspan="colspan" style="text-align: center;">
								<b><i class="fa fa-circle-notch fa-spin"></i> CARREGANDO INFORMAÇÕES...</b>
							</td>
						</tr>
						<tr v-if="!loading && list.length == 0">
							<td :colspan="colspan" style="text-align: center;">
								<b>NENHUM REGISTRO</b>
							</td>
						</tr>
						<tr v-for="(item, idx) in list" :key="idx">
							<td v-if="(on_select !== undefined) && (selected !== undefined)" class="pointered" @click="on_select(item)">
								<i v-if="selected.findIndex(element => element.id == item.id) != -1" class="fas fa-fw fa-check-square"></i>
								<i v-else class="far fa-fw fa-square"></i>
							</td>
							<td v-for="(header, idx) in headers" :key="idx" :title="item[idx]" v-html="item_modified(item[idx], idx, item)"></td>
							<td v-if="(on_select_return_origin !== undefined) && (selected_return_origin !== undefined) && (unselected_return_origin !== undefined)" class="pointered text-center"  @click="on_select_return_origin(item)">
								<i v-if="selected_return_origin.includes(item.id)" class="fas fa-fw fa-check-square"></i>
								<i v-if="unselected_return_origin.includes(item.id)" class="far fa-fw fa-square"></i>
								RETORNAR
							</td>
							<td v-if="$slots.default !== undefined">
								<slot :item="item"></slot>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="col-xs-12 col-lg-12 pagination pagination-bottom">
			<div class="row">
				<div v-if="selected !== undefined && !is_selected" class="col-xs-6 col-lg-6 pagination-total">
					Selecionado {{ countSelected() }} de {{ total }} {{ label }}.
				</div>
				<div v-else-if="selected !== undefined && is_selected" class="col-xs-6 col-lg-6 pagination-total">
					Selecionado {{ selected.length }} {{ label }}.
				</div>
				<div v-else class="col-xs-6 col-lg-6 pagination-total">
					Mostrando {{ total }} {{ label }}.
				</div>
				<div class="col-xs-6 col-lg-6 weight-capacity-total">
					<div class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-truck-loading"></i> Capacidade </span>
						<span class="weight-capacity-right">{{ getWeightCapacity(selected_weight_capacity) }}</span>
					</div>
					<div v-if="label == 'entregas'" class="weight-capacity">
						<span class="weight-capacity-left"><i class="fas fa-fw fa-weight-hanging"></i> Peso </span>
						<span class="weight-capacity-right">{{ getWeight(selected_weight) }}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "RoutingTable",

		props: {
			loading: {
				type: Boolean,
				require: false,
				default: false,
			},
			headers: {
				type: Object,
				require: true,
			},
			ordering: {
				type: Array,
				require: false,
			},
			order: {
				type: String,
				require: false,
			},
			list: {
				type: Array,
				require: true,
			},
			page: {
				type: Number,
				require: false,
				default: 0,
			},
			per_page: {
				type: Number,
				require: false,
				default: 0,
			},
			total: {
				type: Number,
				require: false,
				default: 0,
			},
			label: {
				type: String,
				require: false,
				default: "",
			},
			modifiers: {
				type: Object,
				require: false,
				default: () => {},
			},
			select_all: {
				type: Function,
				require: false,
				default: undefined,
			},
			select_all_return_origin: {
				type: Function,
				require: false,
				default: undefined,
			},
			on_select: {
				type: Function,
				require: false,
				default: undefined,
			},
			on_select_return_origin: {
				type: Function,
				require: false,
				default: undefined,
			},
			selected: {
				type: Array,
				require: false,
				default: undefined,
			},
			selected_return_origin: {
				type: Array,
				require: false,
				default: undefined,
			},
			unselected_return_origin: {
				type: Array,
				require: false,
				default: undefined,
			},
			is_selected: {
				type: Boolean,
				require: false,
				default: false,
			},
			selected_weight_capacity: {
				type: Number,
				require: true,
				default: 0.0,
			},
			selected_weight: {
				type: Number,
				require: false,
				default: 0.0,
			},
		},

		data: function() {
			return {};
		},
		
		computed: {
			order_field: function() {
				if (this.order) return this.order.split("-").shift();
				if (this.ordering && this.ordering.length > 0) return this.ordering[0];
				return false;
			},

			order_direction: function() {
				if (this.order) {
					const split = this.order.split("-");
					if (split.length > 1) return split[1];
				}
				return "DESC";
			},

			start: function() {
				if (this.list.length == 0) return 0;
				return (this.page * this.per_page) + 1;
			},

			end: function() {
				if (this.per_page == 0) {
					return this.total;
				}

				if (this.list.length < this.per_page) {
					return (this.page * this.per_page) + this.list.length;
				} else {
					return (this.page + 1) * this.per_page;
				}
			},

			has_next: function() {
				let last_page = Math.floor(this.total / this.per_page);
				return (this.page < last_page);
			},

			has_prev: function() {
				return (this.page > 0);
			},

			colspan: function() {
				let i = Object.keys(this.headers).length + 1;
				if (this.on_select !== undefined) i++;
				return i;
			},
		},

		methods: {
			item_modified: function(value, index, item) {
				if ((this.modifiers !== undefined) && (this.modifiers[index] != undefined)) {
					return this.modifiers[index](value, item);
				}
				return value;
			},

			reorder: function(new_order) {
				if (new_order == this.order_field) {
					if (this.order_direction == "ASC") {
						new_order += "-DESC";
					} else {
						new_order += "-ASC";
					}
				} else {
					new_order += "-ASC";
				}

				this.$emit("reorder", new_order);
			},

			verifySelectedAll: function(list, selected, is_object) {
				if (list.length > 0) 
				{
					let response = true;
					list.map(r => {
						if (is_object) {
							let index = selected.findIndex(element => element.id == r.id);
							if (index == -1) {
								response = false;
							}
						} else {
							if (!selected.includes(r.id)) {
								response = false;
							}
						}
					});
					return response;
				} else {
					return false;
				}
			},

			countSelected: function() {
				let count = 0;
				this.list.map(r => {
					if (this.selected.findIndex(element => element.id == r.id) != -1) count++;
				});
				return count;
			},

			getWeight: function(weight) {
				let weight_formatted = "";

				if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
				else weight_formatted = (weight / 1000).toFixed(2) + " t";

				return weight_formatted.replace(".", ",");
			},

			getWeightCapacity: function(weight) {
				let weight_formatted = "";

				if (weight < 1000) weight_formatted = weight.toFixed(2) + " kg";
				else weight_formatted = (weight / 1000).toFixed(2) + " t";

				return weight_formatted.replace(".", ",");
			},
			
			/*getWeightPercent: function(capacity, weight) {
				let weight_formatted = "";

				if (weight < 1000) weight_formatted = Math.ceil(weight) + " kg";
				else weight_formatted = Math.ceil(weight / 1000) + " t";

				return weight_formatted;
			},*/
		},
	}
</script>

<style scoped>
.table-wrapper {
	width: 100%;
}

.table {
	width: 100%;
	background: #fff;
	border-spacing: 0px;
	border-collapse: collapse;
}

.table th, .table td {
	text-align: left;
	padding: 10px;
	border-top: 1px solid #f0f0f0;
	font-size: 14px;
}

table > tbody > tr:hover {
	background-color: #f0f0f0;
}

.order {
	background: none;
	border: none;
	color: #aaa;
}
.order.active {
	color: #222;
}


.pointered {
    cursor: pointer;
}

.pagination {
	font-size: 14px;
    padding: 10px 15px;
}

.pagination-top {
	border-bottom: 1px solid #f0f0f0;
}

.pagination-bottom {
	border-top: 1px solid #f0f0f0;
}


.pagination-button {
	float: right;
	background: none;
	border: none;
	width: 30px;
	height: 30px;
	font-size: 20px;
	padding: 0;
	text-align: center;
	color: #999;
}
.pagination-button:disabled {
	color: #ddd;
}


.pagination-total {
	height: 40px;
	line-height: 45px;
}

.weight-capacity-total {
	height: 40px;
	line-height: 45px;
	text-align: right;
}

.weight-capacity {
	display: inline;
	font-size: 12px;
	margin-left: 15px;
}

.weight-capacity-left {
	text-align: left;
	border: 1px solid #ccc;
	/*border-top-left-radius: 3px;
	border-bottom-left-radius: 3px;*/
	background-color: #eee;
	padding: 5px 10px;
}

.weight-capacity-right {
	text-align: right;
	border: 1px solid #ccc;
	/*border-top-right-radius: 3px;
	border-bottom-right-radius: 3px;*/
	background-color: #ccc;
	padding: 5px 10px;
	font-weight: 600;
}

.text-center {
	text-align: center;
}

</style>